import { Box, Typography, Container, Paper,Button } from '@mui/material';
import COLORS from '../../../../../../constants/colors';
import Logo from '../../../../../../assets/logo.png'; // Adjust the path based on your structure
import { useNavigate } from 'react-router-dom';


const TermsOfUse = () => {
    const navigate = useNavigate();
    
        const handleGoBack = () => {
            navigate(-1); // Navigates to the previous page
        };
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            {/* Logo */}
            <Box display="flex" justifyContent="center" mb={3}>
                <img src={Logo} alt="Yamba Africa Logo" style={{ height: 60 }} />
            </Box>

            {/* Paper Container without scrollability */}
            <Paper
                elevation={0}
                sx={{
                    p: 4,
                    backgroundColor: COLORS.background,
                    color: COLORS.text,
                    borderRadius: 2, // Soft edges
                }}
            >
                {/* Title */}
                <Typography variant="h4" fontWeight="bold" color={COLORS.primary} mb={3} textAlign="center">
                    Terms of Use for Yamba Africa Ltd
                </Typography>

                <Typography variant="body2" mb={2} textAlign="center">
                    <strong>Effective Date:</strong> April 1st, 2025
                </Typography>

                <Typography variant="body2" mb={3}>
                    These Terms of Use (“Terms”) govern your access to and use of the Yamba Africa platform (“Platform”), operated by Yamba Africa Ltd, a subsidiary of Delvit Solutions Ltd. By using our services, you agree to be bound by these Terms. Please read them carefully.
                </Typography>

                {/* Sections */}
                {[ 
                    {
                        title: '1. Acceptance of Terms',
                        content: (
                            <>
                                By accessing or using the Platform, you affirm that you have read, understood, and agree to be bound by these Terms and all applicable laws and regulations. If you do not agree with any part of these Terms, you must not use our services.
                            </>
                        ),
                    },
                    {
                        title: '2. Eligibility and Account Registration',
                        content: (
                            <>
                                <strong>Eligibility:</strong> You must be at least 18 years old and possess the legal capacity to enter into a binding contract.
                                <br />
                                <strong>Account Registration:</strong> To use certain features of the Platform, you must register for an account and provide accurate and complete information. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
                            </>
                        ),
                    },
                    {
                        title: '3. Definitions',
                        content: (
                            <>
                                <strong>Campaign:</strong> A fundraising effort initiated by a user on the Platform.
                                <br />
                                <strong>Donation:</strong> A monetary contribution made by a donor to a campaign.
                                <br />
                                <strong>User:</strong> Any individual or entity that registers to use the Platform.
                                <br />
                                <strong>Transaction Fee:</strong> A fee charged on each successful fundraising campaign.
                                <br />
                                <strong>Withdrawal Fee:</strong> A fee applied to each fund withdrawal request from campaign proceeds.
                            </>
                        ),
                    },
                    {
                        title: '4. Platform Services',
                        content: (
                            <>
                                Yamba Africa offers a range of services including, but not limited to:
                                <ul>
                                    <li>Campaign Creation and Management: Users can create and manage fundraising campaigns.</li>
                                    <li>Donation Processing: The Platform facilitates the processing of donations from donors.</li>
                                    <li>Withdrawal of Funds: Campaign organizers may withdraw funds in accordance with the terms detailed herein.</li>
                                    <li>Free Services: Except for the transaction and withdrawal fees detailed below, other Platform services are provided free of charge.</li>
                                </ul>
                            </>
                        ),
                    },
                    {
                        title: '5. Campaign Creation and Management',
                        content: (
                            <>
                                <strong>Limit on Active Campaigns:</strong> Each user may create a maximum of two (2) active campaigns concurrently. An active campaign is defined as one that is currently accepting donations or awaiting withdrawal of funds.
                                <br />
                                <strong>Donor Updates:</strong> Users are required to provide donors with an update on the progress of their campaign at least 14 days after reaching their fundraising target. Failure to provide timely updates may result in suspension or termination of the campaign.
                                <br />
                                <strong>Campaign Content:</strong> All campaigns must comply with our content guidelines. You are solely responsible for ensuring that the information you provide is accurate and lawful.
                            </>
                        ),
                    },
                    {
                        title: '6. Donations, Payment Processing, and Fees',
                        content: (
                            <>
                                <strong>Transaction Fee:</strong> A fee of 4.25% will be charged per transaction. This fee covers the cost of payment processing and maintaining the Platform to ensure that we securely process your payment and also support you reaching as many people as possible.
                                <br />
                                <strong>Payment Processing:</strong> Donations will be processed in accordance with industry standards and through secure payment gateways. By using the Platform, you agree to abide by the terms and conditions of our payment processors.
                                <br />
                                <strong>Refunds and Chargebacks:</strong> Any disputes or refund requests will be handled in accordance with our Refund Policy. In cases of chargebacks, the user may be held responsible for any additional fees incurred.
                            </>
                        ),
                    },
                    {
                        title: '7. Withdrawal Terms and Conditions',
                        content: (
                            <>
                                <strong>Withdrawal Fee:</strong> Each withdrawal request is subject to a fee of 3,000 Ugandan Shillings for withdraws less than 200,000 UGX, Withdraw charge of 5,000 UGX for withdraws between 200,001 UGX and 999,999 UGX, withdraw charge of 10,000 UGX for withdrawals of 1,000,000 UGX and above.
                                <br />
                                <strong>Minimum Withdrawal:</strong> The minimum amount that can be withdrawn per transaction is 20,000 Ugandan Shillings.
                                <br />
                                <strong>Processing Hours:</strong> Withdrawal requests are processed between 8:00 AM and 5:00 PM.
                                <br />
                                <strong>Deposit Timeline:</strong> The requested amount will be deposited into your designated account within 1 to 4 hours from the time of request submission, provided there are no technical issues. In the event of a technical failure, the delay will be communicated promptly to the user.
                            </>
                        ),
                    },
                    {
                        title: '8. Prohibited Conduct',
                        content: (
                            <>
                                You agree not to:
                                <ul>
                                    <li>Use the Platform for unlawful activities or fraudulent purposes.</li>
                                    <li>Create campaigns that contain false, misleading, or deceptive information.</li>
                                    <li>Engage in behavior that interferes with or disrupts the operation of the Platform.</li>
                                    <li>Circumvent any limitations set forth in these Terms, including the restriction on active campaigns.</li>
                                </ul>
                                Failure to comply with these restrictions may result in immediate suspension or termination of your account and access to the Platform.
                            </>
                        ),
                    },
                    {
                        title: '9. Intellectual Property',
                        content: (
                            <>
                                <strong>Ownership:</strong> All content on the Platform, including text, graphics, logos, and software, is the property of Yamba Africa Ltd or its licensors.
                                <br />
                                <strong>Limited License:</strong> You are granted a limited, non-exclusive, non-transferable license to use the Platform strictly in accordance with these Terms.
                                <br />
                                <strong>Restrictions:</strong> You may not reproduce, distribute, modify, or create derivative works of any content from the Platform without explicit written permission from Yamba Africa Ltd.
                            </>
                        ),
                    },
                    {
                        title: '10. Disclaimers and Limitation of Liability',
                        content: (
                            <>
                                <strong>Disclaimer of Warranties:</strong> The Platform is provided “as is” without warranties of any kind, either expressed or implied. Yamba Africa Ltd does not guarantee the continuous or error-free operation of the Platform.
                                <br />
                                <strong>Limitation of Liability:</strong> In no event shall Yamba Africa Ltd, its affiliates, or its respective directors, officers, or employees be liable for any indirect, incidental, consequential, or punitive damages arising out of or relating to your use of the Platform.
                                <br />
                                <strong>Force Majeure:</strong> Yamba Africa Ltd shall not be liable for any failure to perform its obligations due to circumstances beyond its control.
                            </>
                        ),
                    },
                    {
                        title: '11. Indemnification',
                        content: (
                            <>
                                You agree to indemnify and hold harmless Yamba Africa Ltd, its subsidiaries, affiliates, officers, and employees from any claims, damages, obligations, losses, liabilities, costs, or expenses arising from your use of the Platform, your violation of these Terms, or your infringement of any rights of a third party.
                            </>
                        ),
                    },
                    {
                        title: '12. Termination',
                        content: (
                            <>
                                Yamba Africa Ltd reserves the right to suspend or terminate your account and access to the Platform at any time, with or without notice, for conduct that violates these Terms or is harmful to other users or the Platform.
                            </>
                        ),
                    },
                    {
                        title: '13. Dispute Resolution',
                        content: (
                            <>
                                <strong>Governing Law:</strong> These Terms are governed by and construed in accordance with the laws of Uganda.
                                <br />
                                <strong>Arbitration:</strong> Any disputes arising from or relating to these Terms or your use of the Platform shall be resolved through binding arbitration in Uganda, unless otherwise required by law.
                                <br />
                                <strong>Waiver of Class Action:</strong> You agree that any dispute resolution will be conducted on an individual basis and not as part of a class or collective action.
                            </>
                        ),
                    },
                    {
                        title: '14. Changes to These Terms',
                        content: (
                            <>
                                Yamba Africa Ltd reserves the right to update or modify these Terms at any time. Updated versions will be posted on the Platform with a revised effective date. Your continued use of the Platform constitutes your acceptance of the revised Terms.
                            </>
                        ),
                    },
                    {
                        title: '15. Contact Information',
                        content: (
                            <>
                                If you have any questions, concerns, or complaints regarding these Terms, please contact us at:
                                <br />
                                <strong>Email:</strong> <a href="mailto:support@yambaafrica.com">support@yambaafrica.com</a>
                            </>
                        ),
                    },
                ].map((section, index) => (
                    <Box key={index} mt={4}>
                        <Typography variant="h6" fontWeight="bold" color={COLORS.primary} mb={2}>
                            {section.title}
                        </Typography>
                        <Typography variant="body2">{section.content}</Typography>

                       
                    </Box>

                    

                    
                ))}

                 {/* Back Button */}
                 <Box mt={4} display="flex" justifyContent="left">
                                            <Button variant="contained" color="primary" onClick={handleGoBack} sx={{
                                                textTransform:'none',
                                                borderRadius:4
                                            }}>
                                                Go Back
                                            </Button>
                                        </Box>
            </Paper>
        </Container>
    );
};

export default TermsOfUse;
